import { OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

type Constructor<T> = new (...args: any[]) => T;

interface MaybeDestroy {
    ngOnDestroy?(): void;
}

export default function DestroyMixin<T extends Constructor<MaybeDestroy>>(Base: T) {
    return class Destroy extends Base implements OnDestroy {
        protected readonly destroy$ = new Subject<boolean>();

        ngOnDestroy(): void {
            if (super.ngOnDestroy) {
                super.ngOnDestroy();
            }
            this.destroy$.next(true);
            this.destroy$.unsubscribe();
        }
    };
}
